import React, { useContext, useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest, deleteRequest, tabulatorGet } from '../../../api/ApiController';
import { AddIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, EditRowIcon, DeleteIcon, EditIcon, PaperClipIcon, ActivateIcon, DeactivateIcon, RefreshIcon } from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { confirmDialog } from 'primereact/confirmdialog';
import AuthContext from '../../../components/AuthContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css'
import UtilContext from '../../../components/UtilContext';
import { MaintenanceMaskDialogCheckbox } from '../../../components/maintenance/MaintenanceMaskDialogCheckbox';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { createAsyncNavigateHandlers } from '../../../utils/asyncArrayNavigate';
import { navigationContextToQueryParams } from '../../../utils/maintenanceNavigationContext';
import {
  cleanSorters,
  extractSafePaginationParams,
  createDedupedAjaxRequest,
  refreshProgressiveFromStart,
  mergePagedStandardListFiltersAndSorters,
  appendMaintenanceCompanyContactAddPagedFilter,
  restoreMaintenanceCompanyEmbeddedUserMaskToTable,
  applyMaintenanceCompanyEmbeddedColumnLayout,
} from '../../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../../utils/pusherChannel';
import { getEffectiveMask } from '../../../utils/effectiveMask';
import {
  buildMaintenanceMaskAkcieSubItems,
  createConfirmSaveStandardMask,
  createConfirmApplyStandardLayoutToUserMask,
  createSaveUserMaskColumns,
  createOpenMaskDialog,
  createMaskSetFieldHandler,
  createMaskSelectAllHandler,
  createMaskDeselectAllHandler,
  hasApplicableStandardMaskRow,
  MAINTENANCE_MASK_DIALOG_SKIP_FIELDS,
} from '../../../utils/maintenanceTabulatorMaskActions';
import { getTabulatorPersistLayoutEvents } from '../../../utils/tabulatorPersistLayout';
import { inputOnEnterHeaderFilter } from '../../../utils/inputOnEnterHeaderFilter';
import { tabulatorColumnMinWidthFromTitle, TABULATOR_LIST_ID_MIN_WIDTH } from '../../../utils/tabulatorColumnMinWidth';
import {
  buildAuditTabulatorColumns,
  TABULATOR_AUDIT_PROFILES,
} from '../../../utils/tabulatorAuditColumns';
import {
  getEmbeddedCanonicalFieldOrder,
  getEmbeddedDefaultColumnVisibility,
  mergeEmbeddedColumnVisibilityFromSaved,
  applyEmbeddedDataColumnVisibility,
} from '../../../utils/maintenanceCompanyEmbeddedTabulator';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import {
  buildCanonicalPrintFooterHtml,
  buildCanonicalPrintHeaderHtml,
} from '../../../utils/printChrome';
import { uiT } from '../../../utils/uiTranslate';

const MASK_PAGE = 'MaintenanceCompanyContactAdd';
const DEFAULT_COLUMN_VISIBILITY = getEmbeddedDefaultColumnVisibility(MASK_PAGE);
const CANONICAL_FIELD_ORDER = getEmbeddedCanonicalFieldOrder(MASK_PAGE);
const MASK_DIALOG_HELP_TEXT =
  uiT('MaintenanceTemplateList.MaskHelp');

export default function MaintenanceCompanyContactAdd({ maintenance_company, type, navigationContext }) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,setStandardMaskFilter, openChosenNotificationPreferences,getDateFormat,getUserColor,getUserInitials} = useContext(UtilContext);
    const {user} = useContext(AuthContext);

    const canEditCompany = user?.permissions?.includes('edit maintenance-company');

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const submitRef = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const dateTimeFmt = `${dateFmt} HH:mm`;
    const canSetStandardMask = user?.permissions?.includes('set standard mask');

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...DEFAULT_COLUMN_VISIBILITY }));
    const [maskVisible, setMaskVisible] = useState(false);
const [formCompany,setFormCompany] = useState(maintenance_company);
    const [formType, setFormType] = useState(type);
    const currentCompanyIdRef = useRef(maintenance_company?.id ?? null);
    const prevCompanyIdRef = useRef(maintenance_company?.id ?? null);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add maintenance-company"))?false:true);
    const [scrollIcons,setScrollIcons] = useState(() => {
        if (type === 'edit' && maintenance_company) return !canEditCompany;
        return true;
    });
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [visibleCard,setVisibleCard] = useState(false);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);

    const [selectedCard,setSelectedCard] = useState(null);

    const [showTemplateRecordAdd, setShowTemplateRecordAdd] = useState(false);
    const [showIntervalCalibration, setShowIntervalCalibration] = useState(false);
    const [visibleFiles,setVisibleFiles] = useState(false);
    const [images,setImages] = useState('');
    const [templates,setTemplates] = useState('');
    const [viewedImage,setViewedImage] = useState('');

    const [fileList, setFileList] = useState([]);
    const fileListRef = useRef(null);

    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);

    function addNewMaintenanceCard(){
        setSelectedCard(null);
        setShowTemplateRecordAdd(true);
    }

    function editNewMaintenanceCard(){
        const selected = getTable()?.getSelectedData?.() ?? [];
        if (selected.length) { formikUpdate.setValues(selected[0]); setVisibleCard(true); }
    }

    function hideEditCard(){
        formikUpdate.resetForm();
        setVisibleCard(false);
    }

    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const pageSizePc = useMemo(() => {
        const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
        const n = parseInt(v, 10);
        return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);

    useEffect(() => {
        currentCompanyIdRef.current = formCompany?.id ?? null;
    }, [formCompany?.id]);

    useEffect(() => {
        if (formType === 'edit' && formCompany?.id) {
            setScrollIcons(!canEditCompany);
        } else {
            setScrollIcons(true);
        }
    }, [formCompany, formType, canEditCompany]);

    const currentCompanyId = formCompany?.id ?? null;
    useEffect(() => {
        const channel = getPusherChannel();
        if (!channel || currentCompanyId == null) return;
        const DEDUPE_MS = 800;
        const lastHandled = { key: '', at: 0 };
        const shouldSkip = (eventType, id) => {
            if (id == null) return true;
            const key = `${eventType}-${id}`;
            const now = Date.now();
            if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
            lastHandled.key = key;
            lastHandled.at = now;
            return false;
        };
        const onCreated = (data) => {
            const id = data?.id ?? null;
            if (id == null || shouldSkip('company_contact.created', id)) return;
            getRequest(`/api/company_contacts/${id}`).then((res) => {
                const rowData = res?.data?.data ?? res?.data ?? res;
                if (!rowData?.id || rowData.company_id !== currentCompanyId) return;
                const table = getTable();
                const row = table?.getRow?.(rowData.id);
                if (row) row.update(rowData);
                else table?.addData?.([rowData], true);
            }).catch(() => {});
        };
        const onUpdated = (data) => {
            const id = data?.id ?? null;
            if (id == null || shouldSkip('company_contact.updated', id)) return;
            getRequest(`/api/company_contacts/${id}`).then((res) => {
                const rowData = res?.data?.data ?? res?.data ?? res;
                if (!rowData?.id) return;
                const table = getTable();
                const row = table?.getRow?.(rowData.id) ?? table?.getRows?.().find((r) => r.getData().id === id);
                if (rowData.company_id === currentCompanyId) {
                    if (row) row.update(rowData);
                    else table?.addData?.([rowData], true);
                } else if (row) row.delete();
            }).catch(() => {});
        };
        const onDeleted = (data) => {
            const id = data?.id ?? null;
            if (id == null || shouldSkip('company_contact.deleted', id)) return;
            const table = getTable();
            const row = table?.getRow?.(id) ?? table?.getRows?.().find((r) => r.getData().id === id);
            if (row) row.delete();
        };
        channel.bind('company_contact.created', onCreated);
        channel.bind('company_contact.updated', onUpdated);
        channel.bind('company_contact.deleted', onDeleted);
        return () => {
            channel.unbind('company_contact.created', onCreated);
            channel.unbind('company_contact.updated', onUpdated);
            channel.unbind('company_contact.deleted', onDeleted);
        };
    }, [getTable, currentCompanyId]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = {
            module: 'maintenance',
            company_id: currentCompanyIdRef.current ?? '',
            ...extractSafePaginationParams(paramsFromTabulator),
        };
        if (extra.size === undefined || extra.size === null) extra.size = pageSizePc;
        mergePagedStandardListFiltersAndSorters(extra, {
            getTable,
            tableBuiltForParams: tableBuiltRef.current,
            userMaskFilters: state.user_mask_filters,
            maskPage: MASK_PAGE,
            appendFilter: appendMaintenanceCompanyContactAddPagedFilter,
        });
        return extra;
    }, [pageSizePc, getTable, state.user_mask_filters]);
    const baseAjaxRequest = useMemo(
        () => createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        [buildRequestParams]
    );
    const ajaxRequestFunc = useCallback((url, config, params) => baseAjaxRequest(url, config, params), [baseAjaxRequest]);
    const refreshContacts = useCallback(() => {
        captureHScroll();
        refreshFromStart();
    }, [captureHScroll, refreshFromStart]);

    const onSelectRow = () => {
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        const selected = getTable()?.getSelectedData?.() ?? [];
        if (selected.length === 1) {
            if (user.permissions?.includes("edit maintenance-company")) setEditIcon(false);
            if (user.permissions?.includes("delete maintenance-company")) setDeleteIcon(false);
            if (user.permissions?.includes("add maintenance-company")) setCopyIcon(false);
            setSelectedCard(selected[0]);
        }
    };

    const validate = values => {
        const errors = {};
        return errors;
    };

    const formik = useFormik({
        initialValues:{
            module:'maintenance',employee_option:false,employee_id:'',name:'',tel_number:'',email:'',description:'',lecturer_id:''
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                if (value === "employee_id") {
                    formData.append("employee_id",values.employee_id?.id ? values.employee_id?.id : "");
                } else if (value === "lecturer_id") {
                    continue;
                } else {
                    formData.append(value, values[value] != null ? values[value] : "");
                }
            }
            formData.append("company_id", formCompany.id);
            const autoLecturerId = getTechnicianLecturerId(values.employee_option, state.lecturers);
            formData.append("lecturer_id", autoLecturerId);
            postRequest('/api/company_contacts', formData,true)
            .then((response) => {
                if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                formik.resetForm();
                getTable()?.replaceData?.();
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                setShowTemplateRecordAdd(false);
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    const formikUpdate = useFormik({
        initialValues: selectedCard == null ? {
            module:'maintenance',employee_option:false,employee_id:'',name:'',tel_number:'',email:'',description:'',lecturer_id:''
        } : {
            id:selectedCard?.id,module:selectedCard?.module,employee_option:selectedCard?.employee_id ? true : false,employee_id:selectedCard?.employee_id ? state.employees?.filter(employee => employee.id == selectedCard?.employee_id)?.map(employee => ({name:employee?.name,id:employee?.id}))[0] : '',
            name:selectedCard?.employee_id ? selectedCard?.employee?.name : selectedCard?.name,
            tel_number:selectedCard?.employee_id ? selectedCard?.employee?.tel_number : selectedCard?.tel_number,
            email:selectedCard?.employee_id ? selectedCard?.employee?.email : selectedCard?.email,
            description:selectedCard?.description,lecturer_id:selectedCard?.lecturer_id,
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                if (value === "employee_id") {
                    formData.append("employee_id",values.employee_id?.id ? values.employee_id?.id : "");
                } else if (value === "lecturer_id") {
                    continue;
                } else {
                    formData.append(value, values[value] != null ? values[value] : "");
                }
            }
            formData.append("company_id", formCompany.id);
            const autoLecturerId = getTechnicianLecturerId(values.employee_option, state.lecturers);
            formData.append("lecturer_id", autoLecturerId);
            postRequest(`/api/company_contacts/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                getTable()?.replaceData?.();
                if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                setVisibleCard(false);
                formikUpdate.resetForm();
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    const resetDetailUiOnNavigate = useCallback(() => {
        setVisibleCard(false);
        setShowTemplateRecordAdd(false);
        setVisibleFiles(false);
        setSelectedCard(null);
        setImages('');
        setViewedImage('');
        setFileList([]);
        setUpdateFileList([]);
        if (fileListRef.current) fileListRef.current.value = null;
        if (updateFileListRef.current) updateFileListRef.current.value = null;
        setEditIcon(true);
        setDeleteIcon(true);
        setCopyIcon(true);
        setCloseTab(false);
        formik.resetForm();
        formikUpdate.resetForm();
    }, [formik, formikUpdate]);

    useEffect(() => {
        const prevId = prevCompanyIdRef.current;
        const nextId = formCompany?.id;
        if (prevId === nextId) return;
        prevCompanyIdRef.current = nextId;
        if (nextId == null || !tableBuiltRef.current) return;
        inFlightRef.current = { sig: null, promise: null };
        completedCacheRef.current.clear();
        captureHScroll();
        refreshFromStart();
    }, [formCompany?.id, captureHScroll, refreshFromStart]);

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const buildNavigateQueryParams = () => {
            const base = navigationContext ? navigationContextToQueryParams(navigationContext) : '';
            const params = new URLSearchParams(base);
            if (!params.has('type')) {
                params.set('type', 'maintenance');
            }
            return params.toString();
        };
        const applyCompany = (data) => {
            if (!data) return;
            resetDetailUiOnNavigate();
            currentCompanyIdRef.current = data.id ?? null;
            setFormCompany(data);
            setFormType('edit');
            setScrollIcons(!canEditCompany);
        };
        const buildFetchRecord = () => async (direction, currentId) => {
            setDialogText?.(t('Common.LoadingData'));
            setVisible?.(true);
            try {
                const q = buildNavigateQueryParams();
                const url = `/api/companies/navigate?direction=${direction}${currentId ? `&id=${currentId}` : ''}${q ? `&${q}` : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        return createAsyncNavigateHandlers(
            buildFetchRecord(),
            applyCompany,
            () => currentCompanyIdRef.current ?? formCompany?.id
        );
    }, [navigationContext, formCompany?.id, canEditCompany, resetDetailUiOnNavigate, setDialogText, setVisible]);

      function onEditRow(template_record){
        formikUpdate.setValues(template_record);
        setSelectedCard(template_record);
        setVisibleCard(true);
      };
      
      function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
      }

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
    }

    const acceptCalibration = () => {
        const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        Promise.all(rows_to_delete.map(element =>
            deleteRequest(`/api/company_contacts/${element.id}`)
                .then(() => toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') }))
                .catch(() => toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 }))
        )).then(() => {
            captureHScroll();
            refreshFromStart();
        });
    }

    const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecord'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: acceptCalibration
        });
    };
    
    function NameFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.employee_id){
            return rowData?.employee?.name;
        }
        else{
            return rowData?.name;
        }
    }

    function TelNumberFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.employee_id){
            return rowData?.employee?.tel_number;
        }
        else{
            return rowData?.tel_number;
        }
    }

    function EmailFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.employee_id){
            return rowData?.employee?.email;
        }
        else{
            return rowData?.email;
        }
    }

    function TechnicianTypeFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const isInternal = !!rowData.employee_id; // alebo podľa employee_id, ale employee_option je čisté

        return isInternal ? t('Common.InternalEmployee') : t('Common.ServiceCompanyEmployee');
    }

    const remoteHeaderFilter = useCallback(() => true, []);

    const auditTailColumns = useMemo(
        () =>
            buildAuditTabulatorColumns({
                profile: TABULATOR_AUDIT_PROFILES.createdByUpdatedBy,
                includeId: false,
                dateFormat: dateFmt,
                dateTimeFormat: dateTimeFmt,
                getUserColor,
                getUserInitials,
                textHeaderFilter: inputOnEnterHeaderFilter,
                remotePassthrough: true,
            }),
        [dateFmt, dateTimeFmt, getUserColor, getUserInitials]
    );

    const columns = useMemo(
        () => [
            {
                title: '',
                field: 'rowSelection',
                formatter: 'rowSelection',
                titleFormatter: 'rowSelection',
                hozAlign: 'center',
                width: 44,
                minWidth: 44,
                headerSort: false,
                resizable: false,
                frozen: true,
                print: false,
                download: false,
            },
            {
                title: '',
                field: 'editor',
                hozAlign: 'center',
                width: 44,
                minWidth: 44,
                headerSort: false,
                formatter: reactFormatter(<EditRowFormatter />),
                resizable: false,
                frozen: true,
                print: false,
                download: false,
            },
            {
                title: 'ID',
                field: 'id',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: TABULATOR_LIST_ID_MIN_WIDTH,
                widthGrow: 1,
                sorter: 'number',
                hozAlign: 'left',
            },
            {
                title: t('Common.ServiceTechnician'),
                field: 'name',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: tabulatorColumnMinWidthFromTitle(t('Common.ServiceTechnician')),
                widthGrow: 2,
                formatter: reactFormatter(<NameFormatter />),
            },
            {
                title: t('Common.Column.Phone'),
                field: 'tel_number',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Column.Phone')),
                widthGrow: 2,
                formatter: reactFormatter(<TelNumberFormatter />),
            },
            {
                title: 'Email',
                field: 'email',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: tabulatorColumnMinWidthFromTitle('Email'),
                widthGrow: 2,
                formatter: reactFormatter(<EmailFormatter />),
            },
            {
                title: t('Common.Description'),
                field: 'description',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Description')),
                widthGrow: 2,
            },
            {
                title: 'Typ technika',
                field: 'lecturer.name',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: tabulatorColumnMinWidthFromTitle('Typ technika'),
                widthGrow: 2,
                formatter: reactFormatter(<TechnicianTypeFormatter />),
            },
            ...auditTailColumns,
        ],
        [auditTailColumns, remoteHeaderFilter]
    );

    const closeMenu = useCallback(() => {
        setTimeout(() => {
            OverflowMenuProvider.setVisible?.(null);
            setExpandedKeys({});
        }, 0);
    }, []);

    const hasApplicableStandardMask = useMemo(
        () => hasApplicableStandardMaskRow(state.standard_mask_filters, MASK_PAGE, (saved) => mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, saved)),
        [state.standard_mask_filters]
    );

    const openMaskDialog = useCallback(
        createOpenMaskDialog({
            columnsVisible,
            setColumnsVisible,
            defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
            mergeVisibilityFromSaved: (saved) => mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, saved),
            setMaskVisible,
            closeMenu,
        }),
        [columnsVisible, closeMenu]
    );

    const saveUserMaskColumns = useCallback(
        createSaveUserMaskColumns({
            maskPage: MASK_PAGE,
            getTable,
            setUserMaskFilter,
            defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
            columnsVisible,
            setColumnsVisible,
            setMaskVisible,
            toast,
        }),
        [columnsVisible, getTable, setUserMaskFilter, toast]
    );

    const confirmSaveStandardMask = useCallback(
        createConfirmSaveStandardMask({
            maskPage: MASK_PAGE,
            getTable,
            setStandardMaskFilter,
            defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
            toast,
        }),
        [getTable, setStandardMaskFilter, toast]
    );

    const confirmApplyStandardLayoutToUserMask = useCallback(
        createConfirmApplyStandardLayoutToUserMask({
            maskPage: MASK_PAGE,
            state,
            setUserMaskFilter,
            defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
            mergeVisibilityFromSaved: (saved) => mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, saved),
            toast,
            closeMenu,
            onAppliedToTable: ({ colsForSave, attributes }) => {
                const table = getTable();
                if (!table) return;
                isRestoringRef.current = true;
                applyMaintenanceCompanyEmbeddedColumnLayout(table, attributes, CANONICAL_FIELD_ORDER);
                setColumnsVisible(colsForSave);
                applyEmbeddedDataColumnVisibility(table, MASK_PAGE, colsForSave);
                setTimeout(() => {
                    isRestoringRef.current = false;
                    table.redraw?.(true);
                    captureHScroll();
                    refreshFromStart();
                }, 0);
            },
        }),
        [state, closeMenu, getTable, setUserMaskFilter, toast, captureHScroll, refreshFromStart]
    );

    const setMask = useCallback(
        createMaskSetFieldHandler({
            defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
            columnsVisible,
            setColumnsVisible,
            getTable,
            applyVisibilityToTable: (table, vis) => applyEmbeddedDataColumnVisibility(table, MASK_PAGE, vis),
            toast,
        }),
        [columnsVisible, getTable, toast]
    );

    const maskSelectAll = useCallback(
        createMaskSelectAllHandler({
            defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
            setColumnsVisible,
            getTable,
            applyVisibilityToTable: (table, vis) => applyEmbeddedDataColumnVisibility(table, MASK_PAGE, vis),
        }),
        [getTable]
    );

    const maskDeselectAll = useCallback(
        createMaskDeselectAllHandler({
            defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
            setColumnsVisible,
            getTable,
            applyVisibilityToTable: (table, vis) => applyEmbeddedDataColumnVisibility(table, MASK_PAGE, vis),
        }),
        [getTable]
    );

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    function getTechnicianLecturerId(isInternal, lecturers) {
        const name = isInternal ? t('Common.InternalEmployee') : t('Common.ServiceCompanyEmployee');
        const found = lecturers?.find(l => l.name === name);
        return found ? found.id : "";
    }

    useEffect(() => {
        const id = getTechnicianLecturerId(formik.values.employee_option, state.lecturers);
        formik.setFieldValue("lecturer_id", id, false);
    }, [formik.values.employee_option, state.lecturers]);

    useEffect(() => {
        const id = getTechnicianLecturerId(formikUpdate.values.employee_option, state.lecturers);
        formikUpdate.setFieldValue("lecturer_id", id, false);
    }, [formikUpdate.values.employee_option, state.lecturers]);
  
  

    const akcieSubItems = buildMaintenanceMaskAkcieSubItems({
        maskPage: MASK_PAGE,
        getTable,
        setUserMaskFilter,
        cleanSorters,
        captureHScroll,
        refreshFromStart,
        closeMenu,
        openMaskDialog,
        openChosenNotificationPreferences,
        hasApplicableStandardMask,
        confirmApplyStandardLayoutToUserMask,
        itemRenderer,
    });

    const items = [
        {
            key: '0',
            label: t('Common.Actions'),
            icon: 'pi pi-sliders-v',
            template: itemRenderer,
            items: akcieSubItems,
        },
    ];

      function changeEmployee(select_employee){
        if(showTemplateRecordAdd){
            formik.setFieldValue("employee_id",select_employee);
            formik.setFieldValue("tel_number",'');
            formik.setFieldValue("email",'');
            if(select_employee?.id){
                let chosen_employee = state.employees.filter(employee => employee.id == select_employee.id)[0];
                if(chosen_employee){
                    formik.setFieldValue("tel_number",chosen_employee?.tel_number ? chosen_employee?.tel_number : '');
                    formik.setFieldValue("email",chosen_employee?.email ? chosen_employee?.email : '');
                }
            }
        }
        else{
            formikUpdate.setFieldValue("employee_id",select_employee);
            formikUpdate.setFieldValue("tel_number",'');
            formikUpdate.setFieldValue("email",'');
            if(select_employee?.id){
                let chosen_employee = state.employees.filter(employee => employee.id == select_employee.id)[0];
                if(chosen_employee){
                    formikUpdate.setFieldValue("tel_number",chosen_employee?.tel_number ? chosen_employee?.tel_number : '');
                    formikUpdate.setFieldValue("email",chosen_employee?.email ? chosen_employee?.email : '');
                }
            }
        }
      }

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewMaintenanceCard()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editNewMaintenanceCard()}><EditIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" disabled={deleteIcon} onClick={confirm}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={refreshContacts} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" type="button" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" type="button" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" type="button" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" type="button" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('MaintenanceCompanyContactAdd.Text.Upravit_osoby_serv_firmy'),"MaintenanceCompanyContactAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled  onClick={() => setFastView("MaintenanceCompanyContactAdd",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          {canSetStandardMask ? (
            <div className="flex w-10 h-10 px-2 py-1 justify-center" data-targetid="save-standard-mask">
              <button
                type="button"
                title={t('Common.SaveStandardMask')}
                aria-label={t('Common.SaveStandardMask')}
                onClick={confirmSaveStandardMask}
                className="flex items-center justify-center"
              >
                <i className="pi pi-bookmark text-white text-xl" aria-hidden="true" />
              </button>
            </div>
          ) : null}
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
        <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={20} size={50}>
        <div className="w-full relative flex flex-col overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2'>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.SERVISNI_TECHNICI_SERVISNEJ_FIRMY')}</h1>
                <label className="block text-md font-semibold text-gray-800">Por.č.: {formCompany.id}</label>
                        <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.CompanyNameUpper')}</label>
                        <input
                            name='name'
                            type="text"
                            value={formCompany.name} readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="tel_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.PhoneNumber')}</label>
                        <input
                            name='tel_number'
                            type="text"
                            value={formCompany.tel_number} readOnly
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    
                      <div>
                        <label
                            htmlFor="email"
                            className="block text-md font-semibold text-gray-800"
                        >
                            E-MAIL
                        </label>
                        <input
                            name='email'
                            type="email"
                            value={formCompany.email}  readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="contact_person"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >{t('Common.ContactPersonUpper')}</label>
                        <input
                            name='contact_person'
                            type="text"
                            value={formCompany.contact_person}  readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>        
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div>
                        <label
                            htmlFor="address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            ADRESA
                        </label>
                        <input
                            name='address'
                            type="text"
                            value={formCompany.address}  readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="fax"
                            className="block text-md font-semibold text-gray-800"
                        >
                             FAX
                        </label>
                        <input
                            name='fax'
                            type="text"
                            value={formCompany.fax}  readOnly
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="web_address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            WEB. ADRESA
                        </label>
                        <input
                            name='web_address'
                            type="text"
                            value={formCompany.web_address}  readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <textarea
                            name='description'
                            type="text"
                            value={formCompany.description}  readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>  
                        <button className='hidden' type='submit' ref={submitRef}></button>    
            </div>
            </div> 
            </div>
             </SplitterPanel>
    <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={40} style={{minHeight: '110px'}}>
    <ReactTabulator
      key={`maintenance-company-contacts-${formCompany?.id ?? ''}`}
      data={undefined}
      onRef={(r) => (ref.current = r?.current)}
      className='h-full w-full'
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
            const table = getTable();
            if (!table) return;
            isRestoringRef.current = true;
            const effective = getEffectiveMask(MASK_PAGE, state);
            if (effective?.type === 'user' && effective.userMask) {
                restoreMaintenanceCompanyEmbeddedUserMaskToTable(table, effective.userMask, {
                    canonicalFieldOrder: CANONICAL_FIELD_ORDER,
                    setColumnsVisible,
                    applyColumnVisibilityFn: (t, cols) => {
                        const merged = mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, cols);
                        setColumnsVisible(merged);
                        applyEmbeddedDataColumnVisibility(t, MASK_PAGE, merged);
                    },
                });
            } else if (effective?.type === 'standard' && effective.standardMask) {
                restoreMaintenanceCompanyEmbeddedUserMaskToTable(table, effective.standardMask, {
                    canonicalFieldOrder: CANONICAL_FIELD_ORDER,
                    setColumnsVisible,
                    applyColumnVisibilityFn: (t, cols) => {
                        const merged = mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, cols);
                        setColumnsVisible(merged);
                        applyEmbeddedDataColumnVisibility(t, MASK_PAGE, merged);
                    },
                });
            } else {
                applyEmbeddedDataColumnVisibility(table, MASK_PAGE, columnsVisible);
            }
            setTimeout(() => {
                isRestoringRef.current = false;
            }, 0);
            tableBuiltRef.current = true;
            refreshFromStart();
        },
        headerFilterChanged: () => {
            if (!isRestoringRef.current) {
                captureHScroll();
                refreshFromStart();
            }
        },
        sortChanged: () => {
            if (!isRestoringRef.current) {
                captureHScroll();
                refreshFromStart();
            }
        },
        renderComplete: () => restoreHScroll(),
        ...getTabulatorPersistLayoutEvents(MASK_PAGE, ref, setUserMaskFilter),
      }}
      options={{
        layout: 'fitColumns',
        renderHorizontal: "virtual",
        rowHeight: 42,
        movableColumns: true,
        headerSortTristate: true,
        resizableColumnFit: true,
        printAsHtml:true,printHeader: () => buildCanonicalPrintHeaderHtml({
                      branding: state?.branding,
                      productFallbackSrc: defaultProductLogoSrc,
                      companySettingsPrint: state?.company_settings_print,
                      moduleSettings: state?.module_settings,
                      title: t('Print.Title.MaintenanceCompanyContactAdd'),
                      printDateLabel: t('Print.DateLabel'),
                    }),
                    printFooter: () => buildCanonicalPrintFooterHtml({
                      companySettingsPrint: state?.company_settings_print,
                    }),
        printRowRange: "active",
        filterMode: 'remote',
        sortMode: 'remote',
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        ajaxURL: '/api/company_contacts/paged',
        progressiveLoad: 'scroll',
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        pagination: false,
        ajaxRequestFunc,
      }}/>
    </SplitterPanel>
    </Splitter> 
    <Dialog header={t('MaintenanceCompanyContactAdd.Text.Upravit_kontaktnu_osobu')} visible={visibleCard} style={{ width: '40vw' }} onHide={() => hideEditCard()}>
        <form onSubmit={formikUpdate.handleSubmit}>
        <div className="flex align-items-center mt-1">
                <Checkbox name="employee_option" value={"employee_option"} onChange={(e) => formikUpdate.setFieldValue("employee_option",e.checked)} checked={formikUpdate.values.employee_option} className='p-button-sm p-button-text'/>
                <label htmlFor={"employee_option"} className="ml-2">{t('Ui.R67.Nastavit_zamestnanca')}</label>
            </div>
            {!formikUpdate.values.employee_option && <div>
            <label
                htmlFor="name"
                className="block text-md font-semibold text-gray-800"
            >
                Meno
            </label>
            <input
                name='name'
                type="text"
                onChange={formikUpdate.handleChange} value={formikUpdate.values.name}
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>}
            {formikUpdate.values.employee_option && <div>
            <label
                htmlFor="employee_id"
                className="block text-md font-semibold text-gray-800"
            >
                Zamestnanec
            </label>
            <Dropdown value={formikUpdate.values.employee_id} onChange={(e) => changeEmployee(e.value)} 
                options={state.employees.filter(employee => employee?.date_of_departure=="" || employee?.date_of_departure==null).map((employee) => 
                    ({name:employee.name,id:employee.id})
                )} 
                optionLabel="name" required
                filter placeholder={t('Common.SelectEmployee')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
            </div>}
            <div>
            <label
                htmlFor="tel_number"
                className="block text-md font-semibold text-gray-800"
            >{t('EmployeeAdd.Label.Phone')}</label>
            <input
                name='tel_number'
                type="text"
                readOnly={formikUpdate.values.employee_option}
                onChange={formikUpdate.handleChange} value={formikUpdate.values.tel_number}
                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>
        
            <div>
            <label
                htmlFor="email"
                className="block text-md font-semibold text-gray-800"
            >
                E-mail
            </label>
            <input
                name='email'
                type="email"
                readOnly={formikUpdate.values.employee_option}
                onChange={formikUpdate.handleChange} value={formikUpdate.values.email}  
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>  
            <div>
            <label
                htmlFor="description"
                className="block text-md font-semibold text-gray-800"
            >{t('Common.Description')}</label>
            <textarea
                name='description'
                type="text"
                onChange={formikUpdate.handleChange} value={formikUpdate.values.description}
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            >
            </textarea>
            </div>  
            <div>
                <label
                    htmlFor="technician_type"
                    className="block text-md font-semibold text-gray-800"
                >
                    Typ technika
                </label>
                <input
                    name="technician_type"
                    type="text"
                    readOnly
                    value={
                    formikUpdate.values.employee_option
                        ? t('Common.InternalEmployee')
                        : t('Common.ServiceCompanyEmployee')
                    }
                    className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-100 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />
            </div>
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
        </form>
    </Dialog>
        <Dialog header={t('MaintenanceCompanyContactAdd.Text.Pridat_kontaktnu_osobu')} visible={showTemplateRecordAdd} style={{ width: '40vw' }} onHide={() => setShowTemplateRecordAdd(false)}>
        <form onSubmit={formik.handleSubmit}>
            <div className="flex align-items-center mt-1">
                <Checkbox name="employee_option" value={"employee_option"} onChange={(e) => formik.setFieldValue("employee_option",e.checked)} checked={formik.values.employee_option} className='p-button-sm p-button-text'/>
                <label htmlFor={"employee_option"} className="ml-2">{t('Ui.R67.Nastavit_zamestnanca')}</label>
            </div>
            {!formik.values.employee_option && <div>
            <label
                htmlFor="name"
                className="block text-md font-semibold text-gray-800"
            >
                Meno
            </label>
            <input
                name='name'
                type="text"
                onChange={formik.handleChange} value={formik.values.name}
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>}
            {formik.values.employee_option && <div>
            <label
                htmlFor="employee_id"
                className="block text-md font-semibold text-gray-800"
            >
                Zamestnanec
            </label>
            <Dropdown value={formik.values.employee_id} onChange={(e) => changeEmployee(e.value)} 
                options={state.employees.filter(employee => employee?.date_of_departure=="" || employee?.date_of_departure==null).map((employee) => 
                    ({name:employee.name,id:employee.id})
                )} 
                optionLabel="name" required
                filter placeholder={t('Common.SelectEmployee')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
            </div>}
            <div>
            <label
                htmlFor="tel_number"
                className="block text-md font-semibold text-gray-800"
            >{t('EmployeeAdd.Label.Phone')}</label>
            <input
                name='tel_number'
                type="text"
                readOnly={formik.values.employee_option}
                onChange={formik.handleChange} value={formik.values.tel_number}
                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>
        
            <div>
            <label
                htmlFor="email"
                className="block text-md font-semibold text-gray-800"
            >
                E-mail
            </label>
            <input
                name='email'
                type="email"
                readOnly={formik.values.employee_option}
                onChange={formik.handleChange} value={formik.values.email}  
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>  
            <div>
            <label
                htmlFor="description"
                className="block text-md font-semibold text-gray-800"
            >{t('Common.Description')}</label>
            <textarea
                name='description'
                type="text"
                onChange={formik.handleChange} value={formik.values.description}
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            >
            </textarea>
            </div> 
            <div>
                <label
                    htmlFor="technician_type"
                    className="block text-md font-semibold text-gray-800"
                >
                    Typ technika
                </label>
                <input
                    name="technician_type"
                    type="text"
                    readOnly
                    value={
                    formik.values.employee_option
                        ? t('Common.InternalEmployee')
                        : t('Common.ServiceCompanyEmployee')
                    }
                    className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-100 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />
            </div> 
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
        </form>
        </Dialog>
        <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
          <div className="flex flex-col">
            <p className="text-sm text-gray-600 mb-2">{MASK_DIALOG_HELP_TEXT}</p>
            <div className="flex flex-wrap gap-2 mb-2">
              <button type="button" onClick={maskSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.SelectAll')}</button>
              <button type="button" onClick={maskDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.DeselectAllExceptId')}</button>
            </div>
            {columns.map((item) => {
              if (!item?.field || MAINTENANCE_MASK_DIALOG_SKIP_FIELDS.has(item.field)) return null;
              const field = String(item.field);
              const inputId = `${MASK_PAGE}-${field}`;
              return (
                <div key={field} className="flex flex-row border border-black rounded-md p-2 m-1">
                  <MaintenanceMaskDialogCheckbox field={field} inputId={inputId} title={item.title} columnsVisible={columnsVisible} onChange={setMask} />
                  <label htmlFor={inputId} className={`ml-2 ${field === 'id' ? '' : 'cursor-pointer'}`}>{item.title}</label>
                </div>
              );
            })}
            <button type="button" onClick={saveUserMaskColumns} className="m-1 px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-700">{t('Common.SaveUpper')}</button>
          </div>
        </Dialog>
</div>
            </> 
            );
} 
